 // Path: src/subscreens/mechanicadmin/earnings/TopupCancelled.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiXCircle } from "react-icons/fi";
import MechanicAdminLayout from "../../../../layout/mechanic/MechanicMasterLayout.js";
import "../../../../assets/css/mechanic/earning/Earning.css";

const TopupCancelled = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem("pendingTopup"); 
  }, []);

  return (
    <MechanicAdminLayout>
      <div className="me-page" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "60vh" }}>
        <div style={{ textAlign: "center", maxWidth: 420 }}>
          <div style={{ width: 72, height: 72, background: "#FDECEA", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 1.2rem", color: "#DC3545" }}>
            <FiXCircle size={40} />
          </div>
          <h2 style={{ fontFamily: "'Baloo 2', cursive", fontWeight: 700, marginBottom: 8 }}>
            Payment Cancelled
          </h2>
          <p style={{ color: "#888", marginBottom: 24 }}>
            Your wallet topup was not completed. No amount has been charged.
          </p>
          <button
            className="me-topup-confirm-btn"
            style={{ width: "auto", padding: "10px 28px" }}
            onClick={() => navigate("/mechanic-admin/earnings")}
          >
            Back to Earnings
          </button>
        </div>
      </div>
    </MechanicAdminLayout>
  );
};

export default TopupCancelled;